/**
 * 基础菜单 商品管理
 */
<template>
  <div>
    <!-- 面包屑导航 -->
    <el-breadcrumb separator-class="el-icon-arrow-right">
      <el-breadcrumb-item :to="{ path: '/' }">首页</el-breadcrumb-item>
      <el-breadcrumb-item>活动列表</el-breadcrumb-item>
    </el-breadcrumb>
    <!-- 搜索筛选 -->
    <el-form :inline="true" ref="formInline" :model="formInline" class="user-search">

      <el-form-item prop="activityAddressCode" label="活动地区">
        <el-cascader v-model="formInline.activityAddressCode" :options="options123" @change="onChange"
         clearable></el-cascader>
      </el-form-item>


      <el-form-item label="活动ID" prop="id">
        <el-input maxlength="10" type="number" oninput="if(value.length > 3) value=value.slice(0, 3)"  clearable v-model="formInline.id"
          placeholder="输入活动ID"></el-input>
      </el-form-item>

      <el-form-item prop="activityType" label="活动类型">
        <el-select v-model="formInline.activityType" placeholder="不限">
          <el-option label="不限" value=""></el-option>
          <el-option label="精选活动" value="2"></el-option>
          <el-option label="免费活动" value="1"></el-option>
        </el-select>
      </el-form-item>
    
      <el-form-item prop="activityStatus" label="活动状态">
        <el-select v-model="formInline.activityStatus" placeholder="不限">
          <el-option label="不限" value=""></el-option>
          <el-option label="报名中" value="1"></el-option>
          <el-option label="已满员" value="2"></el-option>
          <el-option label="报名截止" value="3"></el-option>
          <el-option label="活动开始" value="4"></el-option>
          <el-option label="活动结束" value="5"></el-option>
        </el-select>
      </el-form-item>
      <el-form-item prop="indexType" label="推荐状态">
        <el-select v-model="formInline.indexType" placeholder="不限">
          <el-option label="不限" value=""></el-option>
          <el-option label="是" value="1"></el-option>
          <el-option label="否" value="0"></el-option>

        </el-select>
      </el-form-item>

      <el-form-item prop="beginTime" label="活动开始时间">
        <el-col :span="11">
          <el-date-picker value-format="yyyy-MM-dd HH:mm:ss" type="datetime" placeholder="选择日期"
            v-model="formInline.beginTime" style="width: 100%;"></el-date-picker>
        </el-col>
        <el-col class="line" :span="2">&nbsp;&nbsp;&nbsp;&nbsp;-</el-col>
        <el-col :span="11">
          <el-form-item prop="endTime" label="">
            <el-date-picker value-format="yyyy-MM-dd HH:mm:ss"   default-time="['23:59:59']" type="datetime" placeholder="选择日期"
              v-model="formInline.endTime" style="width: 100%;"></el-date-picker>

          </el-form-item>

        </el-col>
      </el-form-item>


      <el-form-item prop="createBeginTime" label="活动创建时间">
        <el-col :span="11">
          <el-date-picker value-format="yyyy-MM-dd HH:mm:ss" type="datetime" placeholder="选择日期"
            v-model="formInline.createBeginTime" style="width: 100%;"></el-date-picker>
        </el-col>
        <el-col class="line" :span="2">&nbsp;&nbsp;&nbsp;&nbsp;-</el-col>
        <el-col :span="11">
          <el-form-item prop="createEndTime" label="">
            <el-date-picker value-format="yyyy-MM-dd HH:mm:ss" default-time="['23:59:59']" type="datetime" placeholder="选择日期"
              v-model="formInline.createEndTime" style="width: 100%;"></el-date-picker>

          </el-form-item>
        </el-col>
      </el-form-item>
      <el-form-item>
        <el-button  type="primary" icon="el-icon-search" @click="search">搜索</el-button>
        <el-button  icon="el-icon-delete"  type="info"    @click="resetForm('formInline')">重置</el-button>
        <!-- <el-button  type="primary" icon="el-icon-search" @click="search">搜索</el-button>
        <el-button @click="resetForm('formInline')">重置</el-button> -->
      </el-form-item>
      <el-form-item>
      </el-form-item>
      <div style=" float: right; margin-right: 50px; margin-bottom: 0px; ">
        <el-button  type="success" icon="el-icon-plus" @click="addCogilg">发布活动</el-button>
      </div>
    </el-form>

    <!--列表-->
    <el-table id="educe-table"  ref="multipleTable" stripe :data="listData" highlight-current-row
      v-loading="loading" @select-all="selectall" @select="select" border element-loading-text="拼命加载中"
      style="width: 100%; font-size: 18px;">

      </el-table-column>
      <el-table-column align="center" prop="id" label="活动ID" width="100">
        <template slot-scope="scope">
         <span style="font-size: 25px; font-weight: 700; color: rgb(136, 93, 223); " >{{scope.row.id  }}</span>
        </template>
      </el-table-column>
      <el-table-column prop="image" label="活动图片" width="180">
        <template slot-scope="scope">
          <el-image style="width: 150px; height: 150px;" :src="scope.row.image" :preview-src-list="[scope.row.image]" />
        </template>
      </el-table-column>

      <el-table-column prop="createTime" label="标题" width="250">
        <template slot-scope="scope">
          <el-tag v-if="scope.row.cost == 0" type="primary" disable-transitions>免费活动</el-tag>
          <el-tag v-if="scope.row.cost > 0" type="success" disable-transitions>精选活动</el-tag><br>
          <span>{{ scope.row.title }}</span>
        </template>

      </el-table-column>
      <el-table-column  prop="platformTypeDesc"  align="center" label="展示平台" width="150">
        
    </el-table-column>
      <el-table-column prop="activityAddress" label="活动城市" width="200">
      </el-table-column>

      <el-table-column prop="closeTime" label="截止报名" width="200">
        <template slot-scope="scope">
          <div v-if="value > scope.row.closeTimeMills" style="color: red;">{{ scope.row.closeTimeMills | timestampToTime }} </div>
          <div v-if="value < scope.row.closeTimeMills" style="color: green;">{{ scope.row.closeTimeMills | timestampToTime }}</div>
        </template>
      </el-table-column>
      <el-table-column prop="closeTime" label="活动时间" width="280">
        <template slot-scope="scope">
          <div>开始时间:{{ scope.row.beginTime | timestampToTime }}</div>
          <div>结束时间:{{ scope.row.endTime | timestampToTime }}</div>
        </template>
      </el-table-column>

      <el-table-column align="center" prop="indexDesc" label="推荐状态" width="100">
        <template slot-scope="scope">
          <div v-if='scope.row.indexDesc==0'>否</div>
          <div v-if='scope.row.indexDesc!=0'>是{{scope.row.indexDesc}}</div>
       

        </template>
      </el-table-column>
      <el-table-column prop="closeTime" label="活动状态" width="180">
        <template slot-scope="scope">
          <div v-if="scope.row.status == 1" style="color: #34D0B4;">报名中</div>
          <div v-if="scope.row.status == 2" style="color: #CF1F1F;">已满员</div>
          <div v-if="scope.row.status == 3" style="color: #CF1F1F;">报名截止</div>
          <div v-if="scope.row.status == 4" style="color: #F9AD00;">活动开始</div>
          <div v-if="scope.row.status == 5" style="color: #CF1F1F;">活动结束</div>

        </template>
      </el-table-column>
      <el-table-column align="center" prop="cost" label="费用" width="100">
        <template slot-scope="scope">
          <div>¥{{ scope.row.cost }}元</div>
        </template>
      </el-table-column>
      <el-table-column align="center" prop="cost" label="名额人数" width="100">
        <template slot-scope="scope">
          <div>{{ scope.row.enrollment }}人</div>
        </template>
      </el-table-column>

      <el-table-column prop="cost" label="未签到" width="100">
        <template slot-scope="scope">
          <div>男:{{ scope.row.manNotSignIn || '_' }}</div>
          <div>女:{{ scope.row.woManNotSignIn || '_' }}</div>
        </template>
      </el-table-column>
      <el-table-column prop="cost" label="已签到" width="100">
        <template slot-scope="scope">
          <div>男:{{ scope.row.manSignInEd || '_' }}</div>
          <div>女:{{ scope.row.woManSignInEd || '_' }}</div>
        </template>
      </el-table-column>
      <el-table-column prop="cost" label="已退款" width="100">
        <template slot-scope="scope">
          <div>男:{{ scope.row.manRefund || '_' }}</div>
          <div>女:{{ scope.row.woManRefund || '_' }}</div>
        </template>
      </el-table-column>
      <el-table-column prop="cost" label="已过期" width="100">
        <template slot-scope="scope">
          <div>男:{{ scope.row.manExpire || '_' }}</div>
          <div>女:{{ scope.row.woManExpire || '_' }}</div>
        </template>
      </el-table-column>
      <el-table-column prop="cost" label="已失效" width="100">
        <template slot-scope="scope">
          <div>男:{{ scope.row.manLose || '_' }}</div>
          <div>女:{{ scope.row.woManLose || '_' }}</div>
        </template>
      </el-table-column>

      <el-table-column prop="closeTime" label="创建时间" width="200">
        <template slot-scope="scope">
          <div>{{ scope.row.createTime | timestampToTime }}</div>

        </template>
      </el-table-column>
      <el-table-column prop="statusDesc" label="状态" width="100">
        <template slot-scope="scope">
          <el-tag v-if="scope.row.effective == 0" type="danger" disable-transitions>禁用</el-tag>
          <el-tag v-if="scope.row.effective != 0" type="success" disable-transitions>启用</el-tag>
        </template>
      </el-table-column>
      <el-table-column align="center" fixed="right" label="操作" width="250">
        <template slot-scope="scope">
          <el-button size="mini" @click="handleEdit(scope.$index, scope.row)">查看</el-button>
          <el-button size="mini" type="success" @click="deleteUser(scope.row.id)">管理</el-button>
          <el-button v-if="scope.row.indexDesc ==0" size="mini" type="warning"
            @click="recommend(scope.$index, scope.row)">推荐</el-button>
          <el-button v-if="scope.row.indexDesc != 0" size="mini" type="info"
            @click="recommend(-1, scope.row)">取消推荐</el-button>
            <!-- <el-button v-if="scope.row.status!=5" type="primary" size="mini" @click="summonHandleEdit(scope.$index, scope.row)">召唤活动</el-button>
            <el-button v-if="scope.row.status==5" size="mini">召唤活动</el-button> -->
        </template>
      </el-table-column>
    </el-table>
    <!-- 分页组件 -->
    <Pagination v-bind:child-msg="pageparm" style="float: right; margin-right:0px; height: 50px; margin-top: 50px;"
      @size-change="handleSizeChange" @callFather="callFather"></Pagination>
    <!-- 编辑界面 -->
    <!-- <div style="margin-top: 20px;">
      <el-button @click="selectalls(listData)" type="primary">全选</el-button>
      <el-button @click="imporList" type="success">导出数据</el-button>

    </div> -->
    <el-dialog title="温馨提示" :visible.sync="editFormVisible" width="30%" @click="closeDialog">
      <el-form label-width="120px" :model="editForm" :rules="rules" ref="editForm">

        <span style="margin-left: 52px;">确定要将该活动推荐吗？</span><br>

        <el-form-item label="推荐排序" >
          <el-input style="width: 200px;"  type="number" v-model="recommendform.index" auto-complete="off"
            placeholder="请输入排序"></el-input>
        </el-form-item>

      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button  @click="closeDialog">取消</el-button>
        <el-button  type="primary" :loading="loading" class="title"
          @click="submitForm('editForm')">确定推荐</el-button>
      </div>
    </el-dialog>
<!-- 召唤活动 -->
<el-dialog title="活动推荐" @close="closeDialog(2)" :close-on-click-modal="false" :visible.sync="summonFormVisible" width="30%" @click="closeDialog">
      <el-form label-width="120px" :model="summonList" :rules="rules" ref="editForm">
       
        <el-form-item label="特殊资源" prop="sex">
    <el-radio-group v-model="summonList.sex">
      <el-radio label="0">不限</el-radio>
      <el-radio label="1">男</el-radio>
      <el-radio label="2">女</el-radio>
    </el-radio-group>
  </el-form-item>
   <el-form-item label="年龄区间" prop="beginAge">
          <el-input  maxlength=2 style="width: 200px;"   v-model="summonList.beginAge" auto-complete="off"
            placeholder="开始年龄"></el-input>  ----  
            <el-input style="width: 200px;"  maxlength=3  v-model="summonList.endAge" auto-complete="off"
            placeholder="结束年龄"></el-input>
        </el-form-item>
        <el-form-item label="注册时间" prop="summonListime">
      <el-date-picker
      value-format="yyyy-MM-dd HH:mm:ss"
      @change="getTimelist"
      v-model="summonList.summonListime"
      type="datetimerange"
      range-separator="至"
      start-placeholder="开始日期"
      end-placeholder="结束日期">
    </el-date-picker>
  </el-form-item>
  <el-form-item label="活跃时间" prop="ActiveTime">
      <el-date-picker
      value-format="yyyy-MM-dd HH:mm:ss"
      @change="getTimelists"
      v-model="summonList.ActiveTime"
      type="datetimerange"
      range-separator="至"
      start-placeholder="开始日期"
      end-placeholder="结束日期">
    </el-date-picker>
  </el-form-item>

      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button  @click="closeDialog(2)">取消</el-button>
        <el-button  type="primary" :loading="loading" class="title"
          @click="submitFormcom('editForm')">确定推荐</el-button>
      </div>
    </el-dialog>

  </div>
</template>

<script>
import { deptList, deptSave, deptDelete } from '../../api/userMG'
import Axios from 'axios'
import { login } from "../../api"
import { homeData } from '../../request/home'

import Vue from 'vue'


import Pagination from '../../components/Pagination'
import { query } from 'quill'
export default {
  data() {
    return {
      ssoServer:"",
      dialogVisible: false,
      summonFormVisible:false,
      value: "",
      options123: [],
      options1234123: [],
      aData: new Date(),

      adder: "",
      recommendform: {
        index: "",
        id: ""
      },
      summonListime:'',
      summonList:{
        activityId:"",//活动id
        beginAge:"",//开始年龄
        sex:"",//性别
        beginLastActiveTime:"",//开始活跃时间
        beginRegisterTime:"",//开始注册时间
        endAge:"",//结束年龄
        endLastActiveTime:"",//结束活跃时间
        endRegisterTime:"",//结束注册时间
        sex:"",
        ActiveTime:"",
        summonListime:""

      },
      nshow: true, //switch开启
      fshow: false, //switch关闭
      importList: [],
      loading: false, //是显示加载
      editFormVisible: false, //控制编辑页面显示与隐藏
      title: '添加',
    
      editForm: {
        deptId: '',
        deptName: '',
        deptNo: '',
        token: localStorage.getItem('logintoken')
      },

      // rules表单验证
      rules: {
        
        beginAge: [
          { required: true, message: '年龄区间不能为空不能为空', trigger: 'blur' }
        ],
        ActiveTime: [
          { required: true, message: '活跃时间不能为空', trigger: 'blur' }
        ],
        summonListime: [
          { required: true, message: '注册时间不能为空', trigger: 'blur' }
        ],
        deptName: [
          { required: true, message: '推荐排序不能为空', trigger: 'blur' }
        ],
        
        sex: [
          { required: true, message: '性别不能为空', trigger: 'blur' }
        ],
        index: [
          { required: true, message: '排序不能为空', trigger: 'blur' }
        ],
        deptNo: [{ required: true, message: '请输入部门代码', trigger: 'blur' }]
      },
      formInline: {
        isPC:1,
        // platformType:[3],
        activityAddressCode: "",
        activityType: "",//活动类型
        activityStatus: "",//活动状态
        indexType: "",//推荐状态
        beginTime: "",//开始时间
        endTime: "",//结束时间
        createBeginTime: "",//创建开始时间
        createEndTime: "",//创建结束时间
        id: "",
        current: 1,
        size: 20,
        // token: localStorage.getItem('logintoken')
      },
      // 删除部门
      seletedata: {
        ids: '',
        token: localStorage.getItem('logintoken')
      },
      userparm: [], //搜索权限
      listData: [], //用户数据
      // 分页参数
      pageparm: {
        currentPage: 1,
        pageSize: 20,
        total: 10
      }
    }
  },

  // 注册组件
  components: {
    Pagination
  },
  /**
   * 数据发生改变
   */

  /**
   * 创建完毕
   */
  created() {
    this.ssoServer = Vue.prototype.GLOBAL.ssoServer
    
    this.value=(new Date()).getTime();
    let tokenId = localStorage.getItem('tokenId');
    this.adder = tokenId
  },
  mounted() {
    this.formLIst()
    this.getAddress()
    // this.getAddresss()


  },
  /**
   * 里面的方法只有被调用才会执行
   */
  methods: {
    
    submitFormcom(editForm){
      this.$refs[editForm].validate((valid) => {
          if (valid) {
            const loading = this.$loading({
          lock: true,
          text: 'Loading',
          spinner: 'el-icon-loading',
          background: 'rgba(0, 0, 0, 0.7)'
        });

      
        Axios({
            method: 'post',
            url: this.ssoServer+'/api/activity/activityCall',

            headers: {
              tokenId: this.adder
            },
            data: this.summonList
          }).then(res => {
            if (res.data.code == 0) {
              this.$message({
                type: 'success',
                message: '召唤成功'
              })
              this.summonFormVisible = false
              this.formLIst()

            }else{
              this.$message({
                type: 'warning',
                message: res.data.message
              })
              return

            }

        
          })
        setTimeout(() => {
          loading.close();
        }, 500);
      
            // alert('submit!');
          } else {
            console.log('error submit!!');
            return false;
          }
        });







   

    },
    getTimelist(item){
      this.summonList.beginRegisterTime=item[0]
      this.summonList.endRegisterTime=item[1]
    console.log(item);
    },
    getTimelists(item){
      this.summonList.beginLastActiveTime=item[0]
      this.summonList.endLastActiveTime=item[1]
    console.log(item);
    },
  // 召唤活动
  summonHandleEdit(index,row){
    this.summonList.activityId=row.id
    this.summonFormVisible=true

    console.log(index,row);

  },
    deleteUser(e){
      this.$router.push({
    path:"/officialWebsite/addActivities",
    query:{ //query是个配置项
        id:e
    }
})





    },
    // 推荐
    // getCurrentTime() {
    //     //获取当前时间并打印
    //     var _this = this;
    // let yy = new Date().getFullYear();
    // let mm = new Date().getMonth()+1;
    // let dd = new Date().getDate();
    // let hh = new Date().getHours();
    // let mf = new Date().getMinutes()<10 ? '0'+new Date().getMinutes() : new Date().getMinutes();
    // let ss = new Date().getSeconds()<10 ? '0'+new Date().getSeconds() : new Date().getSeconds();
    // _this.gettime = yy+'/'+mm+'/'+dd+' '+hh+':'+mf+':'+ss;
    // console.log(_this.gettime)  
    // },
    recommend(i, f) {
      if (i == -1) {
        this.recommendform.id = f.id
        this.recommendform.index = 0

        this.$confirm('确定要将该活动推荐取消吗?', '温馨提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(() => {


          Axios({
            method: 'post',
            url: this.ssoServer+'/api/activity/updateIndex',

            headers: {
              tokenId: this.adder
            },
            data: this.recommendform
          }).then(res => {
            if (res.data.code == 0) {
              this.$message({
                type: 'success',
                message: '取消成功'
              })
              this.formLIst()
            }
          })

        }).catch(() => {

        });
        return

      }else{
        this.editFormVisible = true

      }
      this.recommendform.id = f.id

     
      this.recommendform.index = ''

    },




    addCogilg() {



      this.$router.push({
        path: "/officialWebsite/addActivities",
      
      })

    },
    selectall(val) {
      // console.log(val);

      let data = []
      // this.importList=''
      val.forEach((item) => {
        data.push(item.id)
        this.importList = data
        console.log(this.importList);

      })

      // this.importList
      // console.log(val);
    },


    getAddress() {

      Axios({
        method: 'get',
        url: this.ssoServer+'/api/common/getAddressList1',

        headers: {
          tokenId: this.adder
        }
      }).then(res => {
        if (res.data.code == 999) {
          setTimeout(() => {
            localStorage.removeItem('tokenId')

            this.$store.commit('logout', 'false')
            this.$router.push({ path: '/login' })
            this.$message({
              type: 'success',
              message: '登录过期,请重新登录'
            })
          }, 1000)
        }
        // console.log("getAddressList", res.data.data);
        this.options123 = res.data.data

      })
    },


    change1(e) {
      console.log("change1", e);
      if (e.length === 1) {
        this.$message({
          type: 'error',
          message: '请选择详细地址'
        })
      }
      if (e.length === 2) {
        this.formInline.registerAddress = e[1];
      }
    },

    selectalls(rows) {

      if (rows) {
        let data = []
        rows.forEach((item) => {
          data.push(item.id)
          this.importList = data
          console.log(this.importList);

        })
        rows.forEach(row => {

          this.$refs.multipleTable.toggleRowSelection(row);
        });
      } else {
        console.log('1212112');
        this.importList = []

        this.$refs.multipleTable.clearSelection();//清除全选
      }


    },

    onChange(e) {

      this.formInline.activityAddressCode = e[1]
      // console.log( this.formInline.registerAddress);


    },
    selectall(val) {

      let data = []
      val.forEach((item) => {
        data.push(item.id)
        this.importList = data
        console.log(this.importList);

      })

      // this.importList
      console.log(val);
    },
    handleSelectionChange(val) {
      this.multipleSelection = val;
    },
    // 导出数据
    imporList() {
      if (this.importList.length == 0) {

        this.$message({
          type: 'warning',
          message: '请选择要导出的数据'
        })
        return

      } else {
        Axios({
          method: 'post',

          url: this.ssoServer+'/api/platform-account/exportExcel',
          headers: {
            tokenId: this.adder
          },
          data: {
            accountIds: this.importList,
            searchType: 1
          },
          responseType: 'blob'
        }).then(res => {
          const link = document.createElement('a') // 创建a标签
          const blob = new Blob([res.data], { type: 'application/vnd.ms-excel;charset=UTF-8' })
          link.href = window.URL.createObjectURL(blob)
          const filename = res.headers['content-disposition'].split('filename=')[1]
          link.download = decodeURIComponent(filename) // 如果需要自定义下载文件名，则手动设置
          link.click()
          window.URL.revokeObjectURL(link.href)
        })


      }




    },
    select(selection, row) {

      let data = []
      // this.importList=''
      selection.forEach((item) => {
        data.push(item.id)
        this.importList = data
        console.log(this.importList);

      })

      // console.log(this.importList);
      // console.log(selection);
    },
    resetForm(formInline) {
      //  this.formInline =''
      this.$refs[formInline].resetFields();
    },


    formLIst() {

      // let accountListReqVO= this.formInline
      Axios({
        method: 'get',

        url: this.ssoServer+'/api/activity/getList',
        headers: {
          tokenId: this.adder
        },
        params: this.formInline


      }).then(res => {
        console.log(res);
        if (res.data.code == 999) {
          setTimeout(() => {
        
            this.$store.commit('logout', 'false')
            this.$router.push({ path: '/login' })
            this.$message({
              type: 'success',
              message: '登录过期,请重新登录'
            })
          }, 1000)
        }else if(res.data.code==500){
          this.$message({
              type: 'warning',
              message: res.data.message
            })
        }
        this.listData = res.data.data.list

        this.pageparm.currentPage = this.formInline.current
        this.pageparm.pageSize = this.formInline.size
        this.pageparm.total = res.data.data.total
        // console.log(res);
      })

    },
    formatData(row, column, cellValue, index) {

      //把传过来的日期进行回炉重造一下，又创建了一个js的 Date对象，进行重新构造，转为String字符串
      //最终返回 s 就可以了
      var s = new Date(cellValue).toLocaleString();
      return s;
    },
    handleSizeChange(e) {
      // reru console.log(e.pageSize);
      this.formInline.size = e.pageSize
      this.formInline.current = e.currentPage

      this.formLIst()
      // console.log(e);
    },
    // 分页插件事件
    callFather(parm) {
      console.log(parm);

      this.formInline.size = parm.pageSize
      this.formInline.current = parm.currentPage
      this.formLIst()
    },
    // 搜索事件
    search() {



      const loading = this.$loading({
          lock: true,
          text: 'Loading',
          spinner: 'el-icon-loading',
          background: 'rgba(0, 0, 0, 0.7)'
        });
        setTimeout(() => {
          this.formInline.current = 1
      this.value=(new Date()).getTime();

      this.formLIst()
          loading.close();
        }, 500);
      


     
    },
    //显示编辑界面
    handleEdit: function (index, row) {
      this.$router.push({
    path:"/Eventmanagement/Eventdetails",
    query:{ //query是个配置项
        id:row.id
    }
})
      
      // this.editFormVisible = true
      // if (row != undefined && row != 'undefined') {
      //   this.title = '修改'
      //   this.editForm.deptId = row.deptId
      //   this.editForm.deptName = row.deptName
      //   this.editForm.deptNo = row.deptNo
      // } else {
      //   this.title = '添加'
      //   this.editForm.deptId = ''
      //   this.editForm.deptName = ''
      //   this.editForm.deptNo = ''
      // }
    },
    // 编辑、增加页面保存方法
    submitForm(editData) {
      this.$refs[editData].validate(valid => {
        if (valid) {
          if(this.recommendform.index==''){
            return this.$message({
                type: 'warning',
                message: '推荐排序不能为空'
              })
          }
          Axios({
            method: 'post',
            url: this.ssoServer+'/api/activity/updateIndex',

            headers: {
              tokenId: this.adder
            },
            data: this.recommendform
          }).then(res => {
            if (res.data.code == 0) {
              this.$message({
                type: 'success',
                message: '推荐成功'
              })
              this.editFormVisible = false
              this.formLIst()

            }else{
              this.$message({
                type: 'warning',
                message: res.data.message
              })
              return

            }

        
          })
        }
      })
    },
    // async logins() {
    //     // 网络请求
    //     let data = await login('1111111');
    //     // let token = data.token;
    //     // 本地  vuex
    //     // this.$store.commit('LOGIN_IN',token);
    //     this.$router.replace("/")
    // },

    // 删除公司

    // 关闭编辑、增加弹出框
    closeDialog(index) {
      if(index==2){
        this.summonList={}
        this.summonFormVisible=false

      }
      this.editFormVisible = false
    }
  }
}
</script>

<style scoped>
.user-search {
  margin-top: 20px;
}

.userRole {
  width: 100%;
}
</style>

 
 


// WEBPACK FOOTER //
// src/views/officialWebsite/PCactivities.vue